exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".first_lesson_intro__wrapper--3pD7t {\n\theight: 240px;\n}\n\n.first_lesson_intro__animation--2tqTP {\n\twidth: 568px;\n\theight: 100%;\n\tmargin: 0 auto;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "first_lesson_intro__wrapper--3pD7t",
	"animation": "first_lesson_intro__animation--2tqTP"
};